import { render, staticRenderFns } from "./t-language.vue?vue&type=template&id=412a6bae&scoped=true&"
var script = {}
import style0 from "./t-language.vue?vue&type=style&index=0&id=412a6bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412a6bae",
  null
  
)

export default component.exports